<template>
	<div v-if="showpopup" class="popup-container">
      <div class="popup-overlay">
         <div class="popup-content">
            <div class="popup-header">
                  <a class="closePopup" @click="closePopup"></a>
            </div>
            <div class="popup-body">
                  <div class="popup-image">
                     <img v-if="success" class="success" :src="base_url+'/assets/images/icons/icon_submit_success.svg'" alt="Success">
                     <img v-else class="error" :src="base_url+'/assets/images/icons/icon_submit_fail.svg'" alt="Fail">
                  </div>
                  <h2>{{message}}</h2>
            </div>
            <div class="popup-footer">
                  <div class="flex flex-center">
                     <a class="btn btn-primary btn-white" @click="closePopup">Kembali</a>
                     <a  v-if="success" class="btn btn-primary btn-black" @click="confirm">Lanjut</a>
                     <a v-else class="btn btn-primary btn-black" @click="confirm">Simpan</a>
                 </div>
            </div>
         </div>
      </div>
	</div>
</template>

<script>
	export default {
		data () {
			return {
            base_url:base_url,
            loader:true,
            success:true,
            showpopup:false,
            message:"",
			}
		},
		created(){
		},
		methods: {
         show(data){
            this.showpopup  = true;
            this.message = data.message;
            this.success = data.success;
         },
         close(data){
            this.showpopup  = false;
         },
         closePopup(data){
            this.showpopup  = false;
            var data  = {
                  'event': 'incompleteForm',
                  'eventDetail.category': 'Custom Event',
                  'eventDetail.action':'Incomplete Form',
                  'eventDetail.label': 'Return'
            };
            console.log(data)
            dataLayer.push(data)
         },
         confirm(){
             this.$emit('callback',{confirm : true});
         }
		}
	};
</script>

<style scoped lang="scss">
.popup-overlay{
   position: fixed;
   left: 0; top :0;
   width: 100%; height: 100%;
   background-color: rgba(0,0,0,0.7);
   display: flex;
   justify-content: center;
   align-items: center;
   z-index: 9000;
}
.popup-header{
   position: relative;
   text-align: center;
}
.closePopup{
   cursor: pointer;
   display: block;
   width: 35px; height: 35px;
   background-image: url('/assets/images/icons/icon_close.svg');
   background-repeat: no-repeat;
   background-position: center;
   background-size: 15px;
   border-radius: 100px;
   position: absolute;
   right: 0; top: 0;
}
.closePopup:hover{
   background-color: #c00;
}
.popup-content{
   width:90%;
   max-width:600px;
   background-color: #fff;
   margin:auto;
   padding:20px;
   border-radius: 30px;
}
.popup-body{
   padding: 20px 0;
   text-align: center;
   h2{
      font-size: 18px;
      margin:0 0 40px 0;
   }
}
.popup-footer{
   margin-bottom: 30px;
   .btn{
      margin:0 15px;
   }
   .btn-white{
      border:solid 1px #eee;
   }
}
.popup-image{
   width: 130px;
   height: 130px;
   margin:20px auto;
   border-radius: 100px;
   background-color: #FAFAFA;
   display: flex;
   justify-content: center;
   align-items: center;
   img.error{
      width: 80px;
      position: relative;
   }
   img.success{
      width: 60px;
      margin-right: -20px;
   }
}
</style>